import { QueryClient } from "@tanstack/react-query";

import { STALE_TIME } from "#app/http/ReactQueryProvider";
import {
  fetchQuoteRequestLineCustomInputs,
  QuoteRequestLineCustomInputsDto,
} from "#modules/quoteRequestLines/infra/fetchQuoteRequestLineCustomInputs.api";
import { queryKeys } from "#shared/queryKeys/queryKeys";

export const quoteRequestLineCustomInputsQuery = (id: string | undefined) => ({
  queryKey: queryKeys.quoteRequestLines.customInputs(id),
  queryFn: () => fetchQuoteRequestLineCustomInputs(id),
  staleTime: STALE_TIME,
  enabled: !!id,
});

export const getQuoteRequestLineCustomInputsQueryData = (
  queryClient: QueryClient,
  id: string,
): QuoteRequestLineCustomInputsDto | null | undefined => {
  return queryClient.getQueryData<QuoteRequestLineCustomInputsDto | null>(
    queryKeys.quoteRequestLines.customInputs(id),
  );
};

type QuoteRequestLineCustomInputsQueryDataUpdater =
  | QuoteRequestLineCustomInputsDto
  | null
  | undefined
  | ((
      old: QuoteRequestLineCustomInputsDto | null | undefined,
    ) => QuoteRequestLineCustomInputsDto | null | undefined);

export const setQuoteRequestLineCustomInputsQueryData = (
  queryClient: QueryClient,
  id: string,
  updater: QuoteRequestLineCustomInputsQueryDataUpdater,
): QuoteRequestLineCustomInputsDto | null | undefined => {
  return queryClient.setQueryData<QuoteRequestLineCustomInputsDto | null>(
    queryKeys.quoteRequestLines.customInputs(id),
    updater,
  );
};
